// variable.js
//颜色变量
export const colorPalette = {
 "--black": "#000",
  "--white": "#fff",
  "--success":"#43BC60", //积极色
  "--waring":"#FF7800", //警告色
  "--error":"#FC3839", //错误色
  "--info":"#909399",//消息色
  "--link":"#316FFF",//文字超链接
  "--gray-1":"#303133",//一级标题色
  "--gray-2":"#606266",//二级正文色
  "--gray-3":"#909399",//三级辅色
  "--gray-4":"#C04C4CC",//站位文字色
  "--gray-5":"#DCDFE6",//控件边框默认色
  "--gray-6":"#E4E7ED",//二级边框色
  "--gray-7":"#EBEEF5",//分割线
  "--gray-8":"#F2F6FC",//四级边框色
  "--gray-9":"#F5F7FA",//禁用颜色
  "--gray-10":"#F8F9FA",//大背景色
  "--gray-11":"#DEDDDE",//禁用色
  "--gray-12":"#999999",//禁用色
  "--danger":"#FF5454",
  "--blue":"#1972FF",
  "--green":"#1AC5A9",
  //阴影
  "--box-shadow-base":'0px 2px 5px 0px rgba(0, 0, 0, 0.5)',
  "--box-shadow-light":'0px 2px 5px 0px rgba(0, 0, 0, 0.3)',
  // 字体变量
  "--font-size-24": "24px",
  "--font-size-20": "20px",
  "--font-size-16": "16px",
  "--font-size-14": "14px",
  "--font-size-12": "12px",
  //圆角
  "--border-radius-sm": "2px",
  "--border-radius-md": "4px",
  "--border-radius-lg": "30px"
}



  
 